// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__As2Sa","separator":"classes_separator__5N6dJ"};